'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputTypes = require('../../inputTypes');

var _attribute = require('../../attribute/attribute');

var _attribute2 = _interopRequireDefault(_attribute);

var _types = require('../../types');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Attribute


exports.default = (0, _attribute2.default)({
  type: _inputTypes.DATE,
  attribute: 'issue_date',
  display: _types.date,
  input: _types.date,
  api: _types.apiDate,
  label: {
    default: 'Issue Date',
    short: 'Issue Date'
  },
  disabledDates: [{
    after: new Date()
  }]
}); // Types